import { render, staticRenderFns } from "./tableAnalytics.vue?vue&type=template&id=0f4a37b7&scoped=true"
import script from "./tableAnalytics.vue?vue&type=script&lang=js"
export * from "./tableAnalytics.vue?vue&type=script&lang=js"
import style0 from "./tableAnalytics.vue?vue&type=style&index=0&id=0f4a37b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4a37b7",
  null
  
)

export default component.exports